module.exports = __webpack_public_path__ + "img/products-1.adaf63f4.jpg";